import React, { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import RouteSuspense from "../RouteSuspense";

const Login = lazy(() => import("../../pages/auth/Login"));
const Signup = lazy(() => import("../../pages/auth/Signup"));
const LandingPage = lazy(() => import("../../pages/landing/LandingPage"));
const PublicClaimingView = lazy(() => import("../../pages/views/PublicClaimingView"));
const KioskPage = lazy(() => import("../../pages/kiosk/KioskPage"));
const KioskStatusPage = lazy(() => import("../../pages/kiosk/KioskStatusPage"));
const NotFound = lazy(() => import("../../pages/NotFound"));
const BackButtonPage = lazy(() => import("../../pages/kiosk/components/BackButtonPage"));
const KioskLandingPage = lazy(() => import("../../pages/kiosk/components/KioskLandingPage"));
const MobileCustomerResetPage = lazy(() =>
  import("../../pages/kiosk/components/mobile/MobileCustomerResetPage")
);
const MobileCustomerVerifyPage = lazy(() =>
  import("../../pages/kiosk/components/mobile/MobileCustomerVerifyPage")
);
const PaymentSuccess = lazy(() => import("../../pages/payment/PaymentSuccess"));
const PaymentCancel = lazy(() => import("../../pages/payment/PaymentCancel"));
const CustomerLegalPage = lazy(() => import("../../pages/customerLegal/CustomerLegalPage"));
const AssistedRetailPunch = lazy(() => import("../../pages/retailAssisted/AssistedRetailPunch"));

const PublicLiveRoutes = () => (
  <>
    <Route path="/" element={<Navigate to="/login" replace />} />
    <Route path="/sales" element={<RouteSuspense><LandingPage /></RouteSuspense>} />
    <Route path="/login" element={<RouteSuspense><Login /></RouteSuspense>} />
    <Route path="/signup" element={<RouteSuspense><Signup /></RouteSuspense>} />
    <Route path="/back" element={<RouteSuspense><BackButtonPage /></RouteSuspense>} />
    <Route path="/payment/success" element={<RouteSuspense><PaymentSuccess /></RouteSuspense>} />
    <Route path="/payment/cancel" element={<RouteSuspense><PaymentCancel /></RouteSuspense>} />
    <Route
      path="/taccustomer"
      element={<RouteSuspense><CustomerLegalPage type="terms" /></RouteSuspense>}
    />
    <Route
      path="/privacycustomer"
      element={<RouteSuspense><CustomerLegalPage type="privacy" /></RouteSuspense>}
    />
    <Route path="/404" element={<RouteSuspense><NotFound /></RouteSuspense>} />
    <Route path="/mobile/:posId" element={<RouteSuspense><KioskLandingPage /></RouteSuspense>} />
    <Route path="/mobile/reset" element={<RouteSuspense><MobileCustomerResetPage /></RouteSuspense>} />
    <Route
      path="/mobile/:posId/verify"
      element={<RouteSuspense><MobileCustomerVerifyPage /></RouteSuspense>}
    />
    <Route path="/mobile/:posId/order" element={<RouteSuspense><KioskPage /></RouteSuspense>} />
    <Route path="/mobile/:posId/status" element={<RouteSuspense><KioskStatusPage /></RouteSuspense>} />
    <Route
      path="/retail/p/:storeName"
      element={
        <RouteSuspense>
          <AssistedRetailPunch />
        </RouteSuspense>
      }
    />
    <Route path="/c/:posId" element={<RouteSuspense><PublicClaimingView /></RouteSuspense>} />
  </>
);

export default PublicLiveRoutes;
